module.exports = __webpack_public_path__ + "static/media/img20.e84cedfd.jpg";